import { ReactElement } from 'react';
import { Grid } from '@mui/material';
import { Controller } from 'react-hook-form';
import {
  MenuItem,
  ReactHookFormOrganizationAutocomplete,
  ReactHookFormTextField,
} from 'Atoms';
import { useIntl } from 'react-intl';
import { OrganizationDetailsInputType } from 'InputTypes';
import { useGetCountryOptions } from 'Utils';

const OrganizationDetailsForm = ({
  allowEditingReseller,
}: {
  allowEditingReseller?: boolean;
}): ReactElement => {
  const intl = useIntl();
  const countryOptions = useGetCountryOptions();

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Controller<OrganizationDetailsInputType>
          name="organizationName"
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={intl.formatMessage({ id: 'label.name' })}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller<OrganizationDetailsInputType>
          name="invoiceEmailAddress"
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={intl.formatMessage({ id: 'label.invoiceEmailAddress' })}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller<OrganizationDetailsInputType>
          name="address.street"
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={intl.formatMessage({ id: 'label.street' })}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller<OrganizationDetailsInputType>
          name="address.houseNumberWithAddition"
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={intl.formatMessage({
                id: 'label.houseNumberWithAddition',
              })}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller<OrganizationDetailsInputType>
          name="address.postalCode"
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={intl.formatMessage({ id: 'label.postalCode' })}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller<OrganizationDetailsInputType>
          name="address.city"
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={intl.formatMessage({ id: 'label.city' })}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Controller<OrganizationDetailsInputType>
          name="address.country"
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={intl.formatMessage({ id: 'label.country' })}
              select
            >
              {countryOptions.map(({ label, code }) => (
                <MenuItem key={code} value={code}>
                  {label}
                </MenuItem>
              ))}
            </ReactHookFormTextField>
          )}
        />
      </Grid>
      <Grid item xs={6} />
      <Grid item xs={6}>
        <Controller<OrganizationDetailsInputType>
          name="vatNumber"
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={intl.formatMessage({ id: 'label.vatNumber' })}
            />
          )}
        />
      </Grid>
      {allowEditingReseller && (
        <Grid item xs={6}>
          <Controller<OrganizationDetailsInputType>
            name="reseller"
            render={(registered) => (
              <ReactHookFormOrganizationAutocomplete
                {...registered}
                fullWidth
                textField={{
                  label: intl.formatMessage({ id: 'label.reseller' }),
                }}
              />
            )}
          />
        </Grid>
      )}
    </Grid>
  );
};
export default OrganizationDetailsForm;
